define('shared/initializer/form/adapters/mixins/FieldsPrefillable',[
    'shared/lib/RSVP',
    'shared/initializer/form/constants',
    'shared/util/dispatchers/FormDataDispatcher'
],
function (
    RSVP, constants, FormDataDispatcher
) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doPageLoad = function(){
        var me = this;
        var firstNameValue, lastNameValue;

        if (me.prefillable == null) {
            me.prefillable = {};
        }
        if (me.prefillable.fields == null) {
            me.prefillable.fields = {};
        }
        if (me.prefillable.fields.firstName == null) {
            me.prefillable.fields.firstName = 'FirstName';
        }
        if (me.prefillable.fields.lastName == null) {
            me.prefillable.fields.lastName = 'LastName';
        }
        if (me.prefillable.fields.fullName == null) {
            me.prefillable.fields.fullName = 'FullName';
        }

        return RSVP.resolve()
            .then(function(){
                var dispatcher = new FormDataDispatcher( me.$form );
                return dispatcher.dispatch(
                {
                    items:
                    {
                        'name.first':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.first_name',
                                doNotWait: true
                            },{
                                type: 'state',
                                key: 'form.firstname',
                                doNotWait: true
                            }, {
                                type: 'state',
                                key: 'form.FirstName',
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: me.prefillable.fields.firstName,
                                ignoreNull: true
                            }, {
                                publish: function(key, value) {
                                    firstNameValue = value;
                                    return RSVP.resolve();
                                }
                            }]
                        },
                        'name.last':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.last_name',
                                doNotWait: true
                            },{
                                type: 'state',
                                key: 'form.lastname',
                                doNotWait: true
                            }, {
                                type: 'state',
                                key: 'form.LastName',
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: me.prefillable.fields.lastName,
                                ignoreNull: true
                            }, {
                                publish: function(key, value) {
                                    lastNameValue = value;
                                    return RSVP.resolve();
                                }
                            }]
                        },
                        'phone':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.' + 'phone',
                                doNotWait: true
                            },{
                                type: 'state',
                                key: 'form.' + constants.FIELD.PHONE,
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: constants.FIELD.PHONE,
                                ignoreNull: true
                            }]
                        },
                        'email':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.email',
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: 'Email',
                                ignoreNull: true
                            }]
                        },
                        'location.country':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.' + constants.FIELD.LOCATION_COUNTRY,
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: constants.FIELD.LOCATION_COUNTRY,
                                ignoreNull: true
                            }]
                        },
                        'location.state':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.' + constants.FIELD.LOCATION_STATE,
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: constants.FIELD.LOCATION_STATE,
                                ignoreNull: true
                            }]
                        },
                        'location.city':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.' + constants.FIELD.LOCATION_CITY,
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: constants.FIELD.LOCATION_CITY,
                                ignoreNull: true
                            }]
                        },
                        'phone.type':
                        {
                            allowUndefined: true,
                            sources: [{
                                type: 'state',
                                key: 'form.' + constants.FIELD.PHONE_TYPE,
                                doNotWait: true
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: constants.FIELD.PHONE_TYPE,
                                ignoreNull: true
                            }]
                        }
                    },
                    timeout: 1000 * 60 * 60
                });
            })
            .then(function(){
                var dispatcher = new FormDataDispatcher( me.$form );
                return dispatcher.dispatch(
                {
                    items:
                    {
                        'name.full':
                        {
                            allowUndefined: true,
                            sources: [{
                                retrieve: function(){
                                    if (firstNameValue != null && lastNameValue != null) {
                                        return RSVP.resolve(firstNameValue + ' ' + lastNameValue);
                                    }
                                    else {
                                        return RSVP.resolve(null);
                                    }
                                }
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: me.prefillable.fields.fullName
                            }]
                        }
                    }
                });
            });
    };

    return Ctor;
});

